import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';
export function VendorSection() {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    toast.success("Application submitted! We'll be in touch soon.");
    (e.target as HTMLFormElement).reset();
  };
  const benefits = ['Access to fully-equipped commercial kitchen', 'Built-in hungry community audience', 'Marketing and promotional support', 'Low-risk, low-fee pop-up model', 'Mentorship from experienced restaurateurs'];
  return <section id="vendors" className="py-20 lg:py-32 bg-foodCream" data-id="element-240" data-mp="wce7rxsk43ma">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-241" data-mp="wb337vraeru4">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-242" data-mp="114ecs4nhhmpq">
          {/* Pitch */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-243" data-mp="3n76ir1pwzxc">
            <div className="inline-block bg-foodGold text-foodMaroon font-bold px-4 py-1 border-2 border-foodMaroon mb-6 rotate-[-2deg]" data-id="element-244" data-mp="3qi5ocoz4s32e">
              For Chefs & Food Creators
            </div>
            <h2 className="text-5xl md:text-6xl font-extrabold uppercase mb-6" data-id="element-245" data-mp="3gt4bv8rso3t6">
              Cook with Us. <br data-id="element-246" data-mp="3btjbqv0w1pev" />
              <span className="text-foodTomato" data-id="element-247" data-mp="3bu1co4yhwrt4">Grow Your Brand.</span>
            </h2>
            <p className="text-xl font-medium mb-8" data-id="element-248" data-mp="36u6mk3mjo694">
              Whether you're testing a new concept, expanding your catering
              business, or ready for your first pop-up, The Food Pavilion
              provides the launchpad.
            </p>

            <ul className="space-y-4 mb-8" data-id="element-249" data-mp="2xw33ddz17lkh">
              {benefits.map((benefit, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-250" data-mp="110yiafm7hv1x" data-mpi={idx}>
                  <CheckCircle2 className="text-foodOrange shrink-0 mt-1" size={24} data-id="element-251" data-mp="w3oo6mnvgv7r" />
                  <span className="text-lg font-bold" data-id="element-252" data-mp="1f5fdqwyitted">{benefit}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Form */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-foodCard border-4 border-foodMaroon p-8 shadow-[12px_12px_0px_0px_#34302A]" data-id="element-253" data-mp="168523ahsk28x">
            <h3 className="text-3xl font-extrabold uppercase mb-6" data-id="element-254" data-mp="1ow0b6h2gkrvp">
              Apply to Vend
            </h3>
            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-255" data-mp="1tul9gay5h1hi">
              <div className="grid grid-cols-2 gap-4" data-id="element-256" data-mp="dhd6ae4n1fm4">
                <div data-id="element-257" data-mp="djzi4pykaha5">
                  <label className="block text-sm font-bold mb-2" data-id="element-258" data-mp="igzj4mgk0tue">
                    Your Name
                  </label>
                  <input required type="text" className="w-full bg-foodCream border-2 border-foodMaroon p-3 focus:outline-none focus:border-foodOrange focus:ring-1 focus:ring-foodOrange transition-colors" placeholder="Jane Doe" data-id="element-259" data-mp="awp26yq8qqsd" />
                </div>
                <div data-id="element-260" data-mp="ewz5g3mnf33j">
                  <label className="block text-sm font-bold mb-2" data-id="element-261" data-mp="3nevcd3m1o9pu">
                    Business Name
                  </label>
                  <input required type="text" className="w-full bg-foodCream border-2 border-foodMaroon p-3 focus:outline-none focus:border-foodOrange focus:ring-1 focus:ring-foodOrange transition-colors" placeholder="Jane's Tacos" data-id="element-262" data-mp="3je31k5xixwrg" />
                </div>
              </div>

              <div data-id="element-263" data-mp="2zpatsltszeh3">
                <label className="block text-sm font-bold mb-2" data-id="element-264" data-mp="2zq2mnow0my3o">
                  Cuisine Type
                </label>
                <input required type="text" className="w-full bg-foodCream border-2 border-foodMaroon p-3 focus:outline-none focus:border-foodOrange focus:ring-1 focus:ring-foodOrange transition-colors" placeholder="e.g. Vegan Mexican" data-id="element-265" data-mp="3ddcgtsrxvbnz" />
              </div>

              <div className="grid grid-cols-2 gap-4" data-id="element-266" data-mp="3s2qpeynoxp2b">
                <div data-id="element-267" data-mp="3w1pucj9f9ltr">
                  <label className="block text-sm font-bold mb-2" data-id="element-268" data-mp="3w4lrw6hcy8ho">Email</label>
                  <input required type="email" className="w-full bg-foodCream border-2 border-foodMaroon p-3 focus:outline-none focus:border-foodOrange focus:ring-1 focus:ring-foodOrange transition-colors" placeholder="jane@example.com" data-id="element-269" data-mp="4un2dplrfbih" />
                </div>
                <div data-id="element-270" data-mp="2glhdcx6w5zb1">
                  <label className="block text-sm font-bold mb-2" data-id="element-271" data-mp="2gmsdmn14ooxe">Phone</label>
                  <input required type="tel" className="w-full bg-foodCream border-2 border-foodMaroon p-3 focus:outline-none focus:border-foodOrange focus:ring-1 focus:ring-foodOrange transition-colors" placeholder="(555) 123-4567" data-id="element-272" data-mp="xr62e4b3ar1a" />
                </div>
              </div>

              <div data-id="element-273" data-mp="jxeu0z93hd75">
                <label className="block text-sm font-bold mb-2" data-id="element-274" data-mp="1gq0hjeegtthz">
                  Tell us about your concept
                </label>
                <textarea required rows={4} className="w-full bg-foodCream border-2 border-foodMaroon p-3 focus:outline-none focus:border-foodOrange focus:ring-1 focus:ring-foodOrange transition-colors resize-none" placeholder="I want to serve..." data-id="element-275" data-mp="1cp85kde7lai0"></textarea>
              </div>

              <button type="submit" className="w-full bg-foodOrange text-white font-bold text-lg py-4 border-2 border-foodMaroon shadow-[4px_4px_0px_0px_#34302A] hover:translate-y-[2px] hover:translate-x-[2px] hover:shadow-[2px_2px_0px_0px_#34302A] transition-all mt-4" data-id="element-276" data-mp="3nff1mdaqngk8">
                Submit Application
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}